// extracted by mini-css-extract-plugin
module.exports = {"map":"BackgroundMap_map__KJ4Mm","wrapper":"BackgroundMap_wrapper__1hMHW"};